module.exports = __webpack_public_path__ + "media/recipes/147-6f7bc386.png";